import React from 'react';
import './UserDatabase.css';
import { useState } from 'react';
import TutorDashboard from '../../TutorDashboard/TutorDashboard';
import GuardianDatabase from './GuardianDatabase';
import TutorDatabaseAdmin from './TutorDatabaseAdmin';
import TutorDatabaseAdminTwo from './TutorDatabaseAdminTwo';
import GuardianDatabaseTwo from './GuardianDatabaseTwo';

const UserDatabase = () => {
    const [activeTab, setActiveTab] = useState(1); // Set the default active tab to 2 (Tab 2)

    // Function to handle tab click
    const handleTabClick = (tabIndex) => {
        setActiveTab(tabIndex);
    };


    return (
        <div>
            <div className='w-full h-32 flex justify-center items-center bg-gray-50'>
                <h2 className='headingTxt'>User Database</h2>
            </div>
            <div className='px-5 mt-5'>
                <div className='w-full grid grid-cols-2 gap-5 py-2 w-56'>
                    <button onClick={() => handleTabClick(1)} className='w-full px-2 py-2 tabButton text-orange-800 hover:rounded-xl h-10 focus:bg-orange-100 focus:rounded-xl'>Tutor</button>
                    <button onClick={() => handleTabClick(2)} className='w-full px-2 py-2 tabButton text-orange-800 hover:rounded-xl h-10 focus:bg-orange-100 focus:rounded-xl'>Guardian</button>

           </div>
                {/* Content for Tab 1 */}
                {activeTab === 1 && (
                    <div className="tab-content w-full">
                        <TutorDatabaseAdminTwo></TutorDatabaseAdminTwo>
                    </div>
                )}

                {/* Content for Tab 2 */}
                {activeTab === 2 && (
                    <div className='tab-content w-full'>
                        <GuardianDatabaseTwo></GuardianDatabaseTwo>
                    </div>
                )}

            </div>
        </div>
    );
};

export default UserDatabase;